import { cn } from '@xver/utils/classname';
import { Link, useLocation } from 'react-router';
import Tooltip from '../Tooltip/Tooltip';
import { NavigationListItemProps } from './NavigationListItem.types';

const linkClassName =
    'w-full p-1 inline-flex items-center gap-1.5 transition-all duration-100 rounded-md text-[var(--color-sidebar-text)]';

export default function NavigationListItem({
    icon: Icon,
    label,
    to,
    description,
    className,
    disableTooltip,
    badgeCount,
    badgeLabel,
}: NavigationListItemProps) {
    const { pathname } = useLocation();
    const isActive = pathname.startsWith(to);

    const linkElement = (
        <Link
            to={to}
            aria-current={isActive ? 'page' : undefined}
            className={cn(
                linkClassName,
                isActive
                    ? 'bg-(--color-sidebar-item-hover-bg) text-(--color-sidebar-text-hover)'
                    : 'hover:bg-(--color-sidebar-item-hover-bg) hover:text-(--color-sidebar-text-hover)',
                className
            )}
        >
            <Icon size={21} stroke={1.5} aria-hidden="true" />
            <span className="text-[15px]">{label}</span>
            {badgeCount ? (
                <>
                    <span
                        aria-hidden="true"
                        className="ml-auto min-w-5 h-5 px-1.5 inline-flex items-center justify-center rounded-full bg-fg text-page text-xs font-bold"
                    >
                        {badgeCount > 99 ? '99+' : badgeCount}
                    </span>
                    {badgeLabel && <span className="sr-only">, {badgeLabel}</span>}
                </>
            ) : null}
        </Link>
    );

    if (!description || disableTooltip) {
        return linkElement;
    }

    return (
        <Tooltip className="w-full" content={description} position="right">
            {linkElement}
        </Tooltip>
    );
}
